import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-red',
  templateUrl: './red.page.html',
  styleUrls: ['./red.page.scss'],
})
export class RedPage implements OnInit {
  public dataClass = [{ id: 0, name: "Grădiniță 3-4 ani" }, { id: 1, name: "Grădiniță 4-5 ani" }, { id: 2, name: "Grădiniță 5-6 ani" }, { id: 3, name: "Clasa pregătitoare" },
  { id: 4, name: "Clasa I" }, { id: 5, name: "Clasa a II-a" }, { id: 6, name: "Clasa a III-a" }, { id: 7, name: "Clasa a IV-a" }, { id: 8, name: "Clasa a V-a" },
  { id: 9, name: "Clasa a VI-a" }, { id: 10, name: "Clasa a VII-a" }, { id: 11, name: "Clasa a VIII-a" }];
  public buttonStates = ['success', 'success', 'success', 'success', 'success', 'success', 'success', 'success', 'success', 'success', 'success', 'success'];
  public currentClassSelected = -1;
  public arrIndex = [];
  public arrAllLinks= [
    /*Gradi 3-4*/ [],
    /*Gradi 4-5*/ [],
    /*Gradi 5-6*/ [],
    /*Clasa preg*/ [],
    /*Clasa I*/ [],
    /*Clasa II*/ [],
    /*Clasa III*/ [],
    /*Clasa IV*/ [],
    /*Clasa V*/ [],
    /*Clasa VI*/ [],
    /*Clasa VII*/ [],
    /*Clasa VIII*/ []
    
  ];
  public arrAllLinksName= [
    /*Gradi 3-4*/ [      
      'CURLEANCA-NASTASE_GESTIONAREA_STARILOR_EMOTIONALE_CE_NE_INCONJOARA',
      'Furcoi Gabriela-Joc',
      'SIMION ALINA-EVALUARE',
      'OLTEANU GEORGICA-EVALUARE'
    ],
    /*Gradi 4-5*/ [
      'Robulet Georgiana-Numarul si cifra',
      'Ciuca Daniela - Proiect'
    ],
    /*Gradi 5-6*/ [
      'Dumitrascu Andreea-Prietenii_albinutei',
      'Grecu Baias Gina Maria - Joc didactic',
      'Stroe Maria-Joc didactic',
      'Furcoi Gabriela-Sfaturi pentru o viata sanatoasa',
      'Mitroiu Lucia-MATEMATICA SI EXPLORAREA MEDIULUI',
      'COJOCARU DANIELA-EVALUARE'
    ],
    /*Clasa preg*/ [],
    /*Clasa I*/ [
      'Rus Georgeta-Relatia dintre scoala si familie'
    ],
    /*Clasa II*/ [
      'Stoica Carmen - Exemplu de buna practica'
    ],
    /*Clasa III*/ [],
    /*Clasa IV*/ [
      'ADRIANA UNGURENASU - EVALUARE MATEMATICA'
    ],
    /*Clasa V*/ [
      "Ionescu Nicoleta Paula - Dezvoltarea competentelor cheie in cadrul orelor de Limba si literatura romana",
      "Ionescu Nicoleta Paula - Joc didactic",
      "Ionescu Nicoleta Paula - Joc didactic - Traistuta cu povesti"
    ],
    /*Clasa VI*/ [],
    /*Clasa VII*/ [],
    /*Clasa VIII*/ [
      "Ionescu Nicoleta Paula - Harta conceptuala",
      "Tudor Andrei - Primavara"
    ]
  ];
  constructor() { }

  ngOnInit() {
    this.changeClass(0);
  }

  async changeClass(index) {
    this.buttonStates[this.currentClassSelected] = "success";
    this.currentClassSelected = index;
    this.buttonStates[this.currentClassSelected] = "warning";
    this.arrIndex = this.arrAllLinksName[index];
  }

}
